import { useEffect, useState } from 'react';

import { getSpeciesAtLocation, Species } from '../../../api/fishrules/getSpeciesAtLocation';
import { ICoordinates } from '../../../interfaces/geo';
import { reportMykissClientError } from '../../errorHandling/client';
import { useHandleUnmount } from '../useHandleUnmount';

interface Result {
  isLoading: boolean;
  species?: Species;
}

type Params = ICoordinates & { fishrulesSpeciesId: number };

export function useSpeciesAtLocation(params: Params | void): Result {
  const [isLoading, setIsLoading] = useState(false);
  const [species, setSpecies] = useState<Species>();

  const latitude = params?.latitude;
  const longitude = params?.longitude;
  const fishrulesSpeciesId = params?.fishrulesSpeciesId;
  const unmounted = useHandleUnmount();

  useEffect(() => {
    const controller = new AbortController();

    if (fishrulesSpeciesId !== undefined && latitude !== undefined && longitude !== undefined) {
      setIsLoading(true);
      getSpeciesAtLocation({ fishrulesSpeciesId, latitude, longitude }, controller.signal)
        .then(({ results, success }) => {
          if (unmounted.current) {
            return;
          }
          if (success && results.length) {
            setSpecies(results[0]);
          } else {
            setSpecies(undefined);
          }
          setIsLoading(false);
        })
        .catch(error => {
          if (error.name !== 'AbortError') {
            reportMykissClientError(error);
          }
          if (!unmounted.current) {
            setIsLoading(false);
          }
        });
    }

    return () => {
      controller.abort();
    };
  }, [latitude, longitude, fishrulesSpeciesId, unmounted]);

  return { isLoading, species };
}
